var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionMinSpeed16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 9a7 7 0 0 1 14 0v2.533c0 .81-.657 1.467-1.467 1.467h-2.068A3.998 3.998 0 0 1 8 15a3.998 3.998 0 0 1-3.465-2H2.467C1.657 13 1 12.343 1 11.533V9Zm7-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM3.293 7.293a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionMinSpeed16);
export default __webpack_public_path__ + "static/media/ic_action_min_speed_16.7cdb6a4e016ee70fb5da6f5cd8b59e63.svg";
export { ForwardRef as ReactComponent };